import React, { useState } from "react";
import api from "../api/axiosConfig";
import Navbar from "../components/Navbar";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const loginUser = async () => {
    try {
      const res = await api.post("/auth/login", {
        email,
        password,
      });
      localStorage.setItem("token", res.data.token);
      window.location.href = "/";
    } catch (err) {
      alert("Invalid credentials");
    }
  };

  return (
    <>
      <Navbar />
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="card p-5 shadow-lg" style={{ width: '100%', maxWidth: '400px' }}>
          <div className="text-center mb-4">
            <h3 className="fw-bold text-primary">Welcome Back</h3>
            <p className="text-muted">Login to manage your inventory</p>
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold small text-muted">Email Address</label>
            <input
              type="email"
              className="form-control"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label className="form-label fw-bold small text-muted">Password</label>
            <input
              type="password"
              className="form-control"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button className="btn btn-primary w-100 py-2" onClick={loginUser}>
            Sign In
          </button>
        </div>
      </div>
    </>
  );
}